import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", null, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newTodo) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchChange && _ctx.searchChange(...args))),
      onKeypress: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addTodo && _ctx.addTodo(...args)), ["enter"])),
      onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.cancelTodo && _ctx.cancelTodo(...args)), ["esc"])),
      name: "newTodo",
      autocomplete: "on",
      placeholder: "Search or Add..."
    }, null, 544), [
      [_vModelText, _ctx.newTodo]
    ]),
    (_ctx.isShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "icon icon-cancel",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelTodo && _ctx.cancelTodo(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShow && !_ctx.isAlreadyExists)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "icon icon-add",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addTodo && _ctx.addTodo(...args)))
        }))
      : _createCommentVNode("", true)
  ]))
}